export default theme => ({
  hexaSvg3: {
    position: 'absolute',
    top: 0,
    right: 50,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hexaSvg4: {
    position: 'absolute',
    right: -300,
    top: -40,
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hexaSvg2: {
    position: 'absolute',
    right: -100,
    top: 170,
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hexaSvg5: {
    position: 'absolute',
    left: -190,
    top: 170,
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  container: {
    overflow: 'hidden',
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  titleContainer: {
    paddingBottom: theme.spacing(8),
  },
  title: {
    color: theme.palette.pink.main,
    textAlign: 'center',
  },
  hexaContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(6),
    '& .hexa1': {
      stroke: theme.palette.purpule.main,
      fill: theme.palette.common.white,
      color: theme.palette.purpule.main,
      '&:hover': {
        fill: theme.palette.purpule.main,
        color: theme.palette.common.white,
      },
    },
    '& .hexa2': {
      stroke: theme.palette.green.main,
      fill: theme.palette.common.white,
      color: theme.palette.green.main,
      '&:hover': {
        fill: theme.palette.green.main,
        color: theme.palette.common.white,
      },
    },
    '& .hexa3': {
      stroke: theme.palette.blue.main,
      fill: theme.palette.common.white,
      color: theme.palette.blue.main,
      '&:hover': {
        fill: theme.palette.blue.main,
        color: theme.palette.common.white,
      },
    },
    '& .hexa4': {
      stroke: theme.palette.blue.light,
      fill: theme.palette.common.white,
      color: theme.palette.blue.light,
      '&:hover': {
        fill: theme.palette.blue.light,
        color: theme.palette.common.white,
      },
    },
    '& .hexa5': {
      stroke: theme.palette.red.main,
      fill: theme.palette.common.white,
      color: theme.palette.red.main,
      '&:hover': {
        fill: theme.palette.red.main,
        color: theme.palette.common.white,
      },
    },
    '& .hexa6': {
      stroke: theme.palette.orange.main,
      fill: theme.palette.common.white,
      color: theme.palette.orange.main,
      '&:hover': {
        fill: theme.palette.orange.main,
        color: theme.palette.common.white,
      },
    },
    '& .hexa7': {
      stroke: theme.palette.green.light,
      fill: theme.palette.common.white,
      color: theme.palette.green.light,
      '&:hover': {
        fill: theme.palette.green.light,
        color: theme.palette.common.white,
      },
    },
  },
  hexa: {
    cursor: 'pointer',
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      display: 'inline-block',
      top: 'auto !important',
      left: 'auto !important',
      verticalAlign: 'top',
      marginBottom: theme.spacing(2),
    },
  },
  hexaInner: {
    textAlign: 'center',
  },
  hexaTitle: {
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  hexaSubtitle: {
    paddingBottom: theme.spacing(1),
  },
  hexaInnerContainer: {
    position: 'relative',
    display: 'inline-block',
    height: 530,
    width: 778,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      width: 'auto',
    },
    '& > .hexa1': {
      top: 0,
      left: 0,
    },
    '& > .hexa2': {
      top: 0,
      left: 190,
    },
    '& > .hexa3': {
      top: 165,
      left: 95,
    },
    '& > .hexa4': {
      top: 165,
      left: 289,
    },
    '& > .hexa5': {
      top: 165,
      left: 480,
    },
    '& > .hexa6': {
      top: 330,
      left: 382,
    },
    '& > .hexa7': {
      top: 330,
      left: 578,
    },
  },
  captionContainer: {
    textAlign: 'left',
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  captionInner: {
    display: 'inline-block',
    textAlign: 'left',
    border: `1px dashed ${theme.palette.grey[500]}`,
    padding: theme.spacing(2),
    marginTop: -150,
    [theme.breakpoints.down('lg')]: {
      marginTop: 0,
    },
  },
  captionTitle: {
    textTransform: 'uppercase',
  },
  captionDesc: {
    fontWeight: 700,
  },
  captionImg: {
    maxWidth: 500,
    width: '100%',
  },
  axeContainer: {
    position: 'relative',
    paddingBottom: theme.spacing(8),
  },
  axeTitle: {
    paddingBottom: theme.spacing(0.5),
    fontWeight: 900,
  },
  axeSubtitle: {
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  axeTitleSep: {
    width: 70,
    height: 4,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  axeContent: {
    paddingBottom: theme.spacing(2),
  },
  ficheContainer: {
    marginBottom: theme.spacing(3),
  },
  ficheNum: {
    fontWeight: 300,
  },
  ficheTitle: {
    marginBottom: theme.spacing(1),
  },
  axe1TitleContainer: {
    color: theme.palette.purpule.main,
  },
  axe1TitleSep: {
    backgroundColor: theme.palette.purpule.main,
  },
  axe2TitleContainer: {
    color: theme.palette.green.main,
  },
  axe2TitleSep: {
    backgroundColor: theme.palette.green.main,
  },
  axe3TitleContainer: {
    color: theme.palette.blue.main,
  },
  axe3TitleSep: {
    backgroundColor: theme.palette.blue.main,
  },
  axe4TitleContainer: {
    color: theme.palette.blue.light,
  },
  axe4TitleSep: {
    backgroundColor: theme.palette.blue.light,
  },
  axe5TitleContainer: {
    color: theme.palette.red.main,
  },
  axe5TitleSep: {
    backgroundColor: theme.palette.red.main,
  },
  axe6TitleContainer: {
    color: theme.palette.orange.main,
  },
  axe6TitleSep: {
    backgroundColor: theme.palette.orange.main,
  },
  axe7TitleContainer: {
    color: theme.palette.green.light,
  },
  axe7TitleSep: {
    backgroundColor: theme.palette.green.light,
  },
});
